import { activeReport } from 'utils/report';
import { activeFilters } from 'utils/filters';
import { mergeIfPresent } from '../helpers';
import REST from '../rest';

const ENDPOINT = 'api/v1/feedbacks/gallery';

const queryParams = (params = {}) => {
  let filterParams = {};
  filterParams = mergeIfPresent(filterParams, params.filter, (filters) => (filters));
  filterParams = mergeIfPresent(
    filterParams, activeReport(), (report) => ({ report_id: report.id }),
  );
  filterParams = mergeIfPresent(filterParams, activeFilters(), (filters) => (filters));

  return mergeIfPresent({ ...params }, filterParams, (filter) => ({ filter }));
};

const load = (params) => REST.get(ENDPOINT, '', queryParams(params));

export default load;
